import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleXmark,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { v4 as uuidv4 } from "uuid";

import { useSelector, useDispatch } from "react-redux";
import { setApiMessage } from "../../redux/features/globalApiMessageSlice";

const messageIcon = {
  fail: faCircleXmark,
  success: faCircleCheck,
  warn: faCircleExclamation,
};
function GlobalMessage() {
  const [isAlertVisible, setIsAlerVisible] = useState(false);
  const [message, setMessge] = useState([]);
  const [messageType, setMessageType] = useState();
  const globalApiMessageResult = useSelector((state) => state.apimessage);
  const dispatch = useDispatch();
  useEffect(() => {
    setTimeout(() => {
      if (isAlertVisible) {
        dispatch(setApiMessage(null));
        setIsAlerVisible(false);
      }
    }, 5000);
  }, [isAlertVisible])
  useEffect(() => {
    const { apiResponse } = globalApiMessageResult;
    console.log("apiResponse", apiResponse);
    if (apiResponse && (apiResponse.status === "fail" || apiResponse.status === "success")) {
      setIsAlerVisible(true);
      setMessageType(apiResponse.status);
      setMessge([apiResponse.message]);
    } else {
      setIsAlerVisible(false);
      setMessageType(null);
    }
  }, [globalApiMessageResult]);
  const onClose = () => {
    setIsAlerVisible(false);
    dispatch(setApiMessage(null));
  };
  return (
    <>
      {isAlertVisible && message && message.length ? (
        <div className={`globalMessage ${messageType}`}>
          <div>
            {message.map((message, index) => (
              <div key={uuidv4()}>
                <FontAwesomeIcon icon={messageIcon[messageType]} />
                <span className="message">{message}</span>
              </div>
            ))}
            <span onClick={onClose} className="close" title="Close">
              ×
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default GlobalMessage;
